// extracted by mini-css-extract-plugin
export var dividerLine = "_7r-3";
export var itemImage = "_7r-9";
export var lightDivider = "_7r-4";
export var modalContent = "_7r-5";
export var modalContentCompact = "_7r-6";
export var productCard = "_7r-a";
export var productImage = "_7r-b";
export var productImageCompact = "_7r-7";
export var productImagePlaceholder = "_7r-c";
export var productImagePlaceholderCompact = "_7r-8";
export var progressBarBackground = "_7r-1";
export var progressBarContainer = "_7r-0";
export var progressBarFill = "_7r-2";